const getCityFromUrl = (store) => {
	return store.Session.cityFromUrl;
};

export default getCityFromUrl;
